/* ============================================
   BUNDLE TO BUNDLE — Add to Bundle Functionality

   Add this to: Assets → bundle-to-bundle.js

   Then reference it in theme.liquid before </body>:
   <script src="{{ 'bundle-to-bundle.js' | asset_url }}" defer></script>
   ============================================ */

(function() {
  'use strict';

  function removeEditorPasteArtifact() {
    if (!document.body) return;

    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
    var nodesToRemove = [];

    while (walker.nextNode()) {
      var node = walker.currentNode;
      var parentTag = node.parentElement && node.parentElement.tagName;
      if (parentTag === 'SCRIPT' || parentTag === 'STYLE') continue;

      var text = (node.nodeValue || '').trim();
      if (
        text === '```' ||
        text === '4. Click **Save** (top right corner)' ||
        text === 'So it should look like:'
      ) {
        nodesToRemove.push(node);
      }
    }

    nodesToRemove.forEach(function(node) {
      if (node.parentNode) node.parentNode.removeChild(node);
    });

    document.querySelectorAll('link[href^="//cdn.shopifycloud/shopify-plyr"], link[href^="https://cdn.shopifycloud/shopify-plyr"]').forEach(function(link) {
      link.remove();
    });

    document.querySelectorAll('script:not([src])').forEach(function(script) {
      var source = script.textContent || '';
      if (
        source.indexOf("document.addEventListener('DOMContentLoaded'") !== -1 &&
        source.indexOf('...') !== -1
      ) {
        script.remove();
      }
    });
  }

  removeEditorPasteArtifact();

  const BTB = {
    // ---- CONFIG ----
    selectors: {
      section: '.complete-the-look',
      productCard: '.complete-the-look__product',
      productMini: '.product-card-mini',
      productsContainer: '.complete-the-look__products',
      ctaButton: '.complete-the-look__cta-button',
      textContent: '.complete-the-look__text-content'
    },

    // ---- INIT ----
    init() {
      const sections = document.querySelectorAll(this.selectors.section);
      if (!sections.length) return;

      sections.forEach(section => {
        this.setupSection(section);
      });
    },

    // ---- SETUP EACH SECTION ----
    setupSection(section) {
      // Replace the existing CTA with "Add All to Bundle"
      this.replaceMainCTA(section);

      // Add "Add to Bundle" buttons to each product card
      const cards = section.querySelectorAll(this.selectors.productCard);
      cards.forEach(card => {
        this.setupProductCard(card);
      });
    },

    // ---- REPLACE MAIN CTA ----
    replaceMainCTA(section) {
      const ctaWrapper = section.querySelector(this.selectors.ctaButton);
      if (!ctaWrapper) return;

      // Create new "Add All to Bundle" button
      const addAllBtn = document.createElement('button');
      addAllBtn.className = 'btb-add-all-btn';
      addAllBtn.type = 'button';
      addAllBtn.innerHTML = `
        <span class="btb-add-all-btn__text">Add All to Bundle</span>
        <span class="btb-add-all-btn__loading" style="display:none;">Adding...</span>
      `;

      addAllBtn.addEventListener('click', () => {
        this.handleAddAll(section, addAllBtn);
      });

      // Replace the existing button
      ctaWrapper.innerHTML = '';
      ctaWrapper.appendChild(addAllBtn);
    },

    // ---- SETUP INDIVIDUAL PRODUCT CARD ----
    setupProductCard(card) {
      const productLink = card.querySelector('a[href*="/products/"]');
      if (!productLink) return;

      const productHandle = this.getProductHandle(productLink.href);
      if (!productHandle) return;

      // Store handle on the card for later use
      card.dataset.productHandle = productHandle;

      // Create the add-to-bundle widget
      const widget = document.createElement('div');
      widget.className = 'btb-widget';
      widget.innerHTML = `
        <div class="btb-size-selector" style="display:none;">
          <select class="btb-size-select">
            <option value="">Select Size</option>
          </select>
        </div>
        <button type="button" class="btb-add-btn">
          <span class="btb-add-btn__text">Add to Bundle</span>
          <span class="btb-add-btn__loading" style="display:none;">Adding...</span>
          <span class="btb-add-btn__success" style="display:none;">&#10003; Added!</span>
        </button>
      `;

      // Append widget after the product card mini
      const miniCard = card.querySelector(this.selectors.productMini) || card;
      miniCard.appendChild(widget);

      // Fetch product data and populate sizes
      this.fetchProductData(productHandle, widget);

      // Button click handler
      const btn = widget.querySelector('.btb-add-btn');
      const sizeSelector = widget.querySelector('.btb-size-selector');
      const sizeSelect = widget.querySelector('.btb-size-select');

      btn.addEventListener('click', () => {
        // If sizes not shown yet, show them
        if (sizeSelector.style.display === 'none' && sizeSelect.options.length > 2) {
          sizeSelector.style.display = 'block';
          sizeSelect.focus();
          return;
        }

        // If only one variant (no real sizes), add directly
        if (sizeSelect.options.length <= 2 && sizeSelect.value) {
          this.addToCart(sizeSelect.value, btn);
          return;
        }

        // If size selected, add to cart
        if (sizeSelect.value) {
          this.addToCart(sizeSelect.value, btn);
        } else {
          // Highlight the size selector
          sizeSelector.style.display = 'block';
          sizeSelect.classList.add('btb-size-select--error');
          setTimeout(() => sizeSelect.classList.remove('btb-size-select--error'), 1500);
        }
      });

      // Auto-submit when size is selected (optional nice UX)
      sizeSelect.addEventListener('change', () => {
        if (sizeSelect.value) {
          this.addToCart(sizeSelect.value, btn);
        }
      });
    },

    // ---- EXTRACT PRODUCT HANDLE FROM URL ----
    getProductHandle(url) {
      const match = url.match(/\/products\/([^?#/]+)/);
      return match ? match[1] : null;
    },

    // ---- FETCH PRODUCT DATA ----
    fetchProductData(handle, widget) {
      const sizeSelect = widget.querySelector('.btb-size-select');
      const sizeSelector = widget.querySelector('.btb-size-selector');

      fetch(`/products/${handle}.js`)
        .then(res => res.json())
        .then(product => {
          // Store product data on the widget
          widget.dataset.productId = product.id;

          const variants = product.variants;

          if (variants.length === 1) {
            // Only one variant — no size selection needed
            // Add a hidden option with the variant ID
            const opt = document.createElement('option');
            opt.value = variants[0].id;
            opt.textContent = 'One Size';
            opt.selected = true;
            sizeSelect.appendChild(opt);
            // Keep size selector hidden, button adds directly
            return;
          }

          // Multiple variants — populate the dropdown
          variants.forEach(variant => {
            const opt = document.createElement('option');
            opt.value = variant.id;
            opt.textContent = variant.title;
            opt.disabled = !variant.available;
            if (!variant.available) {
              opt.textContent += ' — Sold Out';
            }
            sizeSelect.appendChild(opt);
          });
        })
        .catch(err => {
          console.error('BTB: Failed to fetch product', handle, err);
        });
    },

    // ---- ADD SINGLE ITEM TO CART ----
    addToCart(variantId, btn) {
      if (!variantId) return;

      this.setBtnState(btn, 'loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: parseInt(variantId),
            quantity: 1
          }]
        })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(() => {
        this.setBtnState(btn, 'success');
        this.updateCartCount();

        // Reset button after 2 seconds
        setTimeout(() => {
          this.setBtnState(btn, 'default');
        }, 2000);
      })
      .catch(err => {
        console.error('BTB: Add to cart error', err);
        this.setBtnState(btn, 'default');
        alert('Could not add to bundle. Please try again or check if you have an active membership.');
      });
    },

    // ---- ADD ALL TO CART ----
    handleAddAll(section, btn) {
      const cards = section.querySelectorAll(this.selectors.productCard);
      const widgets = section.querySelectorAll('.btb-widget');
      const items = [];
      let needsSizes = false;

      widgets.forEach(widget => {
        const sizeSelect = widget.querySelector('.btb-size-select');
        const sizeSelector = widget.querySelector('.btb-size-selector');

        if (!sizeSelect.value) {
          // Show size selector for items without a selection
          if (sizeSelect.options.length > 2) {
            sizeSelector.style.display = 'block';
            sizeSelect.classList.add('btb-size-select--error');
            setTimeout(() => sizeSelect.classList.remove('btb-size-select--error'), 1500);
            needsSizes = true;
          }
        } else {
          items.push({
            id: parseInt(sizeSelect.value),
            quantity: 1
          });
        }
      });

      if (needsSizes) {
        // Scroll to first unselected size
        const firstUnselected = section.querySelector('.btb-size-select--error');
        if (firstUnselected) {
          firstUnselected.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
        return;
      }

      if (items.length === 0) return;

      this.setBtnState(btn, 'loading');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items })
      })
      .then(res => {
        if (!res.ok) throw new Error('Add all failed');
        return res.json();
      })
      .then(() => {
        this.setBtnState(btn, 'success');
        this.updateCartCount();

        // Also mark individual buttons as success
        widgets.forEach(widget => {
          const individualBtn = widget.querySelector('.btb-add-btn');
          this.setBtnState(individualBtn, 'success');
          setTimeout(() => this.setBtnState(individualBtn, 'default'), 2000);
        });

        setTimeout(() => {
          this.setBtnState(btn, 'default');
        }, 2000);
      })
      .catch(err => {
        console.error('BTB: Add all error', err);
        this.setBtnState(btn, 'default');
        alert('Could not add items to bundle. Please try again or check your membership status.');
      });
    },

    // ---- BUTTON STATE HELPER ----
    setBtnState(btn, state) {
      if (!btn) return;
      const text = btn.querySelector('[class$="__text"]');
      const loading = btn.querySelector('[class$="__loading"]');
      const success = btn.querySelector('[class$="__success"]');

      if (text) text.style.display = state === 'default' ? '' : 'none';
      if (loading) loading.style.display = state === 'loading' ? '' : 'none';
      if (success) success.style.display = state === 'success' ? '' : 'none';

      btn.disabled = state === 'loading';
    },

    // ---- UPDATE CART COUNT IN HEADER ----
    updateCartCount() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          // Try common Shopify cart count selectors
          const counters = document.querySelectorAll(
            '.cart-count, .cart__count, [data-cart-count], .header__cart-count, .js-cart-count'
          );
          counters.forEach(el => {
            el.textContent = cart.item_count;
          });

          // Dispatch a custom event for themes that listen
          document.dispatchEvent(new CustomEvent('cart:updated', { detail: cart }));

          // Stiletto-specific: trigger cart update
          if (window.theme && window.theme.cart) {
            try { window.theme.cart.getCart(); } catch(e) {}
          }
        });
    }
  };

  // ---- LAUNCH ----
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => BTB.init());
  } else {
    BTB.init();
  }
})();
